import s3 from "react-aws-s3";
import Cookies from 'js-cookie'

const accessKeyId = atob("QUtJQVNYTkRCQkVONTIzTVhTRVM="); 
const secretAccessKey = atob("SXlxOHRGRDFCd0MyYTBjeUhBaXNxYjR1c3FWemJSRnpBL3pwR3Zuag==");
const config = {
  bucketName: "images-nwlt",
  albumName: "photos",
  region: "us-west-2",
  accessKeyId: accessKeyId,
  secretAccessKey: secretAccessKey,
};
function dataURLtoFile(dataurl, filename) {
 
    var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), 
        n = bstr.length, 
        u8arr = new Uint8Array(n);
        
    while(n--){
        u8arr[n] = bstr.charCodeAt(n);
    }
    
    return new File([u8arr], filename, {type:mime});
}
export async function amazonUploadProfileImage(files,name) {
    var file = dataURLtoFile(files,name);
   // let data1 = base64_decode(files);
  let s3Client = new s3(config);
  return s3Client
    .uploadFile(file, name)
    .then((data) => data)
    .catch((err) => console.error(err));
}
